<script setup lang="ts">
import { formatPhone } from '@/composables';
import { PersonStores } from '@/store';

const profileStore = PersonStores.useUserProfileStore();
</script>

<template>
  <Card class="p-fluid">
    <template #header>
      <h2>Referrals</h2>
    </template>
    <template #content>
      <DataTable
        :value="profileStore.person.student_referrals"
        :scrollable="true"
        loading-icon="logo-spinner"
        :loading="profileStore.loading"
        responsive-layout="scroll"
        scroll-height="440px"
      >
        <template #empty>There are no referrals for this student</template>
        <Column field="referral_type" header="Referral Type" />
        <Column field="referrer_title" header="Title/Relationship" />
        <Column header="Referred By">
          <template #body="{ data }">
            <span v-text="`${data.referrer_first_name}&nbsp;${data.referrer_last_name}`" />
          </template>
        </Column>
        <Column header="Email">
          <template #body="{ data }">
            <a v-if="data.referrer_email" :href="`mailto:${data.referrer_email}`" v-text="data.referrer_email" />
            <span v-else v-text="'N/A'" />
          </template>
        </Column>
        <Column header="Phone">
          <template #body="{ data }">
            <span v-if="data.referrer_phone" v-text="formatPhone(data.referrer_phone)" />
            <span v-else v-text="'N/A'" />
          </template>
        </Column>
        <Column
          field="referral_referred_at"
          header="Date of Referral"
          header-class="justify-content-center"
          body-class="justify-content-center"
          body-style="font-size: .8725rem;"
        />
        <Column
          field="referral_approved_at"
          header="Date of Approval"
          header-class="justify-content-center"
          body-class="justify-content-center"
          body-style="font-size: .8725rem;"
        />
      </DataTable>
    </template>
  </Card>
</template>
